import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, getToken } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
const siteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY;
const configured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId && siteKey);
let appCheck = null;

if (configured && typeof window !== 'undefined') {
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export async function appCheckHeaders() {
  if (!appCheck) return {};
  const result = await getToken(appCheck);
  return result?.token ? { 'X-Firebase-AppCheck': result.token } : {};
}
